import { render, staticRenderFns } from "./OrganizationForm.vue?vue&type=template&id=a1063144&scoped=true"
import script from "./OrganizationForm.vue?vue&type=script&lang=js"
export * from "./OrganizationForm.vue?vue&type=script&lang=js"
import style0 from "./OrganizationForm.vue?vue&type=style&index=0&id=a1063144&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1063144",
  null
  
)

export default component.exports